import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "Components/UI";
import Button from "Components/UI/Button";
import { Container } from "./styles";
import premiumImg from "Static/images/logo-crow-free.png";

interface IPremiumCard {
  role: number;
  onRedirect: (role: number) => void;
}

const PremiumCard: FC<IPremiumCard> = ({ role, onRedirect }) => {
  const { t } = useTranslation('config');

  return (
    <Container>
      <img
        className="imgPremium"
        src={premiumImg}
        alt={t('premiumCard.imgAlt')}
      />
      <span className="textTitle">
        {role === 1
          ? t('premiumCard.upgradePersonal')
          : t('premiumCard.upgradeCompany')}
      </span>
      <span className="textDescription">
        {t('premiumCard.description')}
      </span>
      <Button
        className="btnPremium"
        ispremium="true"
        onClick={() => onRedirect(role)}
      >
        <Icon
          icon="crown"
          customSize={12}
          className="iconCrow"
        />
        {role === 1
          ? t('premiumCard.acquireProPersonal')
          : t('premiumCard.acquireProCompany')}
      </Button>
    </Container>
  )
}

export default PremiumCard;
